'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import DynamicLogo from '@components/DynamicLogo';
import CommonDynamicVideo from '../CommonDynamicVideo';
import CommonDynamicButton from '../CommonDynamicButton';
import CustomlModelElement from '@components/CustomlModelElement';
import CustomVideo from '@components/CustomVideo';
import { Desktop } from '@components/Desktop';
import { Mobile } from '@components/Mobile';
import cn from './style.module.scss';

/* ---------- SECTION ---------- */

const WestminsterTowerWatchFilmSection = (props: any) => {
  return (
    <Stack
      component="section"
      className={cn.westminsterTowerWatchFilm}
      sx={{
        backgroundImage: `url(${props.images.westminster_tower_dark_background?.src})`,
      }}
    >
      <Box className={cn.westminsterWatchFilmInner}>
        <Box className={cn.westminsterWatchFilmCompany}>
          <Box className={cn.westminsterWatchFilmCompany__element}>
            <DynamicLogo
              logoImage={props?.images?.westminster_tower_logo_light?.src}
              alt="Logo"
            />
          </Box>
        </Box>
        <Box className={cn.westminsterWatchFilmStory}>
          <Box className={cn.westminsterWatchFilmStoryInner}>
            <Mobile>
              <CustomVideo
                poster={
                  props.images?.westminster_tower_panoramic_slide_1_mobile
                    ?.src || ' '
                }
                src={props.videos?.westminsterTowerBannerstoryMobile?.src}
                className={cn.residencesBannerVideo}
              />
            </Mobile>
            <Desktop>
              <CustomVideo
                controls={true}
                poster={
                  props.images?.westminster_tower_panoramic_slide_1?.src || ' '
                }
                src={props.videos?.westminsterTowerBannerstoryDesktop?.src}
                className={cn.residencesBannerVideo}
              />
            </Desktop>
          </Box>
        </Box>
        <Box className={cn.westminsterWatchFilmButton}>
          <CommonDynamicButton
            label={
              props.locale?.section?.westminsterTowerBannerButton ||
              'Register your interest'
            }
            onClick={() => {
              props.onCloseModal?.();

              setTimeout(() => {
                const el = document.getElementById(
                  'westminsterTowerRegistrationID'
                );
                el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 300);
            }}
          />
        </Box>
      </Box>
    </Stack>
  );
};

/* ---------- MAIN ---------- */

export default function WestminsterTowerWatchFilm(props: any) {
  return (
    <CustomlModelElement
      videoModelClassName={cn.westminsterTowerWatchModel}
      closeIconClassName={cn.westminsterWelcomeClose}
      showIcon={false}
      playCursorImage={null}
      blockClassName={cn.westminsterWelcomePane}
      modelContent={({ close }) => (
        <WestminsterTowerWatchFilmSection {...props} onCloseModal={close} />
      )}
    >
      <CommonDynamicButton
        label={
          props.locale?.section?.westminsterTowerWelcomeButton ||
          'Register your interest'
        }
      />
    </CustomlModelElement>
  );
}
